import { DirectionSwitchButton } from '@eti/debug';
import { routes } from '../../../constants/routesAndApisConstants';
import DebugAccessibilityReview from './DebugAccessibilityReview';
import DebugTexts from './DebugTexts';
import DebugSiteProperties from './DebugSiteProperties';
import DebugThemeSelect from './DebugThemeSelect';
import DebugOrderDetailPage from './DebugOrderDetailPage';
import DebugOrderStatusPage from './DebugOrderStatusPage';

const DebugCommonComponents = () => {
  const isOrderDetailsPage = window.location.pathname.includes(routes.ORDER_DETAILS);
  const isOrderStatusPage = window.location.pathname.includes(routes.ORDER_STATUS);

  return (
    <>
      <DirectionSwitchButton />
      <DebugTexts />
      <DebugSiteProperties />
      {isOrderDetailsPage && <DebugOrderDetailPage />}
      {isOrderStatusPage && <DebugOrderStatusPage />}
      <DebugAccessibilityReview />
      <DebugThemeSelect />
    </>
  );
};

export default DebugCommonComponents;
